import { registeration } from './reducers';
export default registeration;
